import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lightbox from './Lightbox';

const galleryImages = [
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/413c3362-6caa-463f-abce-86e84d27420f_compressed_Captura-de-pantalla-2026-07-16-a-las-14.12.28.webp',
    alt: 'Casa de El Golfo - Outdoor terrace with volcanic mountain views',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/4daac3bc-44fd-491a-a2d9-76a030df4bb3_compressed_Captura-de-pantalla-2026-07-16-a-las-14.12.16.webp',
    alt: 'Casa de El Golfo - Bright living room with green doors and wooden ceiling',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/ec7d179b-f007-46fb-9362-22d2ca8ef431_compressed_Captura-de-pantalla-2026-07-16-a-las-14.12.49.webp',
    alt: 'Casa de El Golfo - Cozy living room with grey sofa and green doors',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/6362049e-f122-4869-96a8-9019e3e8404c_compressed_Captura-de-pantalla-2026-07-16-a-las-14.12.37.webp',
    alt: 'Casa de El Golfo - Dining area with kitchen view and green windows',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/44c41f70-7f61-4550-bc8e-1c04b5a03727_compressed_Captura-de-pantalla-2026-07-16-a-las-14.12.59.webp',
    alt: 'Casa de El Golfo - Dining area with view into the living room',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/a3e52cf5-f236-498f-be63-ecd1249b623d_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.04.webp',
    alt: 'Casa de El Golfo - Kitchen with wooden counter and appliances',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/fc0e9b4e-66c5-4ef7-9c95-e2504b2c4b98_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.25.webp',
    alt: 'Casa de El Golfo - Kitchen breakfast bar with fruit bowl',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/e2ff0e78-5a4c-47bb-a4ad-c52c5cb077e1_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.20.webp',
    alt: 'Casa de El Golfo - Master bedroom with wooden furniture',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/8ba665fc-ae25-48e3-9deb-70a1263e913d_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.50.webp',
    alt: 'Casa de El Golfo - Second bedroom with bunk beds',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/68379352-338b-45ac-8ad4-be263e9020af_compressed_Captura-de-pantalla-2026-07-16-a-las-14.13.34.webp',
    alt: 'Casa de El Golfo - Storage shelves with view into the bathroom',
  },
];

export default function GolfoGallery() {
  const { t } = useTranslation();
  const [lightboxIndex, setLightboxIndex] = useState<number>(-1);

  const handlePrev = () => {
    setLightboxIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
  };

  const handleNext = () => {
    setLightboxIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
  };

  return (
    <section id="gallery" className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">{t('gallery_subtitle')}</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">{t('gallery_title_golfo')}</h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="break-inside-avoid mb-4 md:mb-5 rounded-lg overflow-hidden cursor-pointer group relative"
              onClick={() => setLightboxIndex(i)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                <span className="w-10 h-10 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform scale-75 group-hover:scale-100">
                  <i className="ri-zoom-in-line text-xl"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightboxIndex >= 0 && (
        <Lightbox
          images={galleryImages}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(-1)}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      )}
    </section>
  );
}